// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import DeleteComment from 'components/Comments/columns/Formatters/FormatDateColumn/DeleteComment'
import React from 'react'
import { object, string } from 'prop-types'
import { useSelector } from 'react-redux'
import { exportValue } from 'components/DataTable/Formatters/FormatEpochToYYYYMMDD'

const FormatDateColumn = props => {
  const {
    customProps,
    columnKey,
    idRoot,
    rowData,
  } = props

  const {
    deleteComment,
    removeComment,
  } = customProps

  const canDeleteComment = useSelector(({ user }) => user.get('userId') === rowData.createUserId)

  const date = exportValue(props)

  return (
    <div>
      <span
        id={`${idRoot}-${rowData[columnKey]}`}
        className={'flex-1'}
        title={date}>
        {date}
      </span>
      {
        canDeleteComment &&
        <DeleteComment
          deleteComment={deleteComment}
          idRoot={`${idRoot}-delete-comment`}
          removeComment={removeComment}
          rowData={rowData} />
      }
    </div>
  )
}

FormatDateColumn.propTypes = {
  columnKey: string.isRequired,
  customProps: object.isRequired,
  idRoot: string.isRequired,
  rowData: object.isRequired,
}

export default FormatDateColumn